<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <get-price :getPrice="getPrice" />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import TravelInsuranceData from '@/data/company-page-data/sompo-sigorta/cross-pages/TravelInsurance'
export default {
  metaInfo: {
    title: 'Sompo Sigorta Seyahat Sağlık Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content: "Sompo Sigorta'dan online seyahat sağlık sigortası fiyatı alarak yurtiçi - yurt dışı seyahatlerinizi güvence altına alabilirsiniz. Hemen fiyat teklifi isteyin."
      }
    ]
  },
  name: 'SompoSigortaTravelHealtInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: TravelInsuranceData.headerContent,
      crossPageContent: TravelInsuranceData.crossPageContent,
      faqTitle: TravelInsuranceData.faqTitle,
      faqTitleDesc: TravelInsuranceData.faqTitleDesc,
      getPrice: TravelInsuranceData.getPrice
    }
  }
}
</script>
